module.exports = new __parcel__URL__("../newNick.4a7f00f8.png").toString();